import React, { useEffect, useState } from "react"
import { Link } from "gatsby"

const NavLinks = props => {
  const [blogPath, setBlogPath] = useState(false)

  useEffect(() => {
    checkPath(props.location.pathname)
  }, [])

  let checkPath = path => {
    let sub = path.substring(0, 5)
    if (sub === "/blog") {
      setBlogPath(true)
    } else {
      return null
    }
  }

  let links = props.projects.sort((a,b) => (a.node.sort > b.node.sort) ? 1 : ((b.node.sort > a.node.sort) ? -1 : 0))

  links = links.map(project => {
    if ("/" + project.node.slug === props.location.pathname) {
      return (
        <li class="active">
          <Link to={"/" + project.node.slug + "/"}>
            <div class="nav-record-link">
              <div class="title">{project.node.title}</div>
              <div class="nav-producer">{project.node.producer}</div>
              <div class="catalog-number">{project.node.catalog}</div>
            </div>
          </Link>
        </li>
      )
    } else {
      return (
        <li>
          <Link to={"/" + project.node.slug + "/"}>
            <div class="nav-record-link">
              <div class="title">{project.node.title}</div>
              <div class="nav-producer">{project.node.producer}</div>
              <div class="catalog-number">{project.node.catalog}</div>
            </div>
          </Link>
        </li>
      )
    }
  })

  return (
    <div class={props.isOpen ? "nav-links" : "nav-links closed"}>
      <ul class="project-links">
        {links}
        {blogPath ? (
          <li class="active">
            <Link to="/blog/">Blog</Link>
          </li>
        ) : (
          <li>
            <Link to="/blog/">Blog</Link>
          </li>
        )}
        {props.location.pathname === "/info/" ? (
          <li class="active">
            <Link to="/info/">Info</Link>
          </li>
        ) : (
          <li>
            <Link to="/info/">Info</Link>
          </li>
        )}
      </ul>
    </div>
  )
}

export default NavLinks
